import {
  faFacebook,
  faGithub,
  faInstagram,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.scss";

const Footer = () => {
  const Facebook = <FontAwesomeIcon icon={faFacebook} />;
  const Instagram = <FontAwesomeIcon icon={faInstagram} />;
  const Linkedin = <FontAwesomeIcon icon={faLinkedin} />;
  const Envelop = <FontAwesomeIcon icon={faEnvelope} />;
  const Github = <FontAwesomeIcon icon={faGithub} />;


  return (
    <footer style={{ backgroundColor:"#0a0119", overflow: "hidden" }}>
      <hr  className="single-raw"/>
      <div>
        <Container className="pb-5 pt-5">
          <Row>
            <Col className="pb-5" xs={12} md={6}>
              <h1 className="text-white">Let's Work Together</h1>
              <p className="text-white">
                Have a project you'd like to discuss?
                <br /> Fell free to contact.
              </p>
              <button className="contact-btn mt-3">
                <Link to="#contact" >
                Get in Touch
              </Link>
              </button>
            </Col>
            <Col className="footer-section pb-5" xs={12} md={6}>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://mail.google.com"
                >
                  <span>{Envelop}</span>Gmail
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/nurulalam61"
                >
                  <span>{Facebook}</span>Facebook
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/arifulislam964"
                >
                  <span>{Instagram}</span>Instagram
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/nurulalam21"
                >
                  <span>{Linkedin}</span>Linkedin
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/arif286"
                >
                  <span>{Github}</span>Github
                </a>
              </li>
            </Col>
          </Row>
        </Container>
        <div className="d-flex justify-content-center">
          <hr  className="single-raw w-75"/>
        </div>
        <div
          style={{
            height: "70px",
          }}
          className="d-flex align-items-center justify-content-center"
        >
          <small className="text-white align-self-center">
            © {new Date().getFullYear()} Nurul Alam. All rights reserved.
          </small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
